import React from "react";

import { useState } from "react";

import { Alert } from "@material-ui/lab";
import {  Snackbar } from "@material-ui/core";
import { useTranslation } from "react-i18next";

const ZatckNotification = () => {
    const { t } = useTranslation(["forms"]);
    const [snack, setSnack] = useState({
      vertical: "top",
      openSnak: true,
      horizontal: "right",
      severit: "warning",
      time: 10000,
    });
  
    return (
      <div>
  
        <Snackbar
          anchorOrigin={{ vertical: snack.vertical, horizontal: snack.horizontal }}
          open={snack.openSnak}
          autoHideDuration={snack.time}
          onClose={()=>{setSnack({ ...snack, openSnak: false })}}
          key={"12"}
         
        >
          <Alert onClose={()=>{
            setSnack({ ...snack, openSnak: false })
          }} severity={snack.severit}>
            {" "}
            {t("zatca-unposted-invoices-warning")}{" "}
          </Alert>
        </Snackbar>
      </div>
    );
  };

  export default ZatckNotification;